import {
  addBackLink,
  addHiddenTemplateRow,
  addSpacerRow,
  addTitleRow,
  applyColumnLayout,
  borderFourColHeaderRow,
  BODY_FONT,
  DATA_START_ROW,
  HEADER_FONT_12,
  HEADER_ROW,
  setCell,
  setValueDataRow,
  setupSheetView,
} from "./detailSheetCommon";

const COL_START = 4;
const COL_END = 7;

function formatTurnoverPct(value) {
  if (value === null || value === undefined || value === "") return "";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return num.toFixed(2);
}

export function buildBusinessActivitiesSheet(workbook, sectionA) {
  const ws = workbook.addWorksheet("Details of business activities");
  applyColumnLayout(
    ws,
    {
      A: 9.1796875,
      B: 9.1796875,
      C: 9.1796875,
      D: 6.7265625,
      E: 31.453125,
      F: 34.7265625,
      G: 28.81640625,
      H: 9.1796875,
      I: 9.1796875,
      J: 9.1796875,
    },
    ["A", "B"]
  );
  for (let col = 11; col <= 16384; col += 1) {
    const column = ws.getColumn(col);
    column.width = 9.1796875;
    column.hidden = true;
  }

  setupSheetView(ws, {
    xSplit: 3,
    ySplit: 11,
    topLeftCell: "D12",
    zoomScale: 85,
  });

  for (let r = 1; r <= 5; r += 1) {
    const row = ws.getRow(r);
    row.height = 15;
    row.hidden = true;
  }

  addBackLink(ws, COL_END);
  addTitleRow(
    ws,
    COL_START,
    COL_END,
    "Details of business activities (accounting for 90% of the turnover)"
  );

  borderFourColHeaderRow(ws, HEADER_ROW);
  ws.getRow(HEADER_ROW).height = 15.5;
  [
    { col: COL_START, label: "Sr. No." },
    { col: 5, label: "Description of Main Activity" },
    { col: 6, label: "Description of Business Activity" },
    { col: COL_END, label: "% of Turnover of the entity" },
  ].forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, { font: HEADER_FONT_12, bordered: false });
  });

  addHiddenTemplateRow(ws, COL_START, COL_END);
  addSpacerRow(ws, COL_START, COL_END);

  const activities = sectionA?.productServices?.businessActivities || [];
  const rows = activities.length ? activities : [];

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setValueDataRow(ws, row, COL_START, COL_END, item, [
      { col: COL_START, value: String(idx + 1), align: "center", fill: undefined, font: BODY_FONT },
      { col: 5, value: item?.mainActivity ?? "", align: "left" },
      { col: 6, value: item?.businessActivity ?? "", align: "left" },
      { col: COL_END, value: formatTurnoverPct(item?.turnoverPercentage), align: "right" },
    ]);
  });

  for (let r = 1; r <= 5; r += 1) {
    const row = ws.getRow(r);
    row.height = 15;
    row.hidden = true;
  }

  return ws;
}
